import { Auth } from '@/type';
import socialSiteRepository from '@/social/site/site-repository';
import { getCredentials, accountRepository } from '@/iam/external';
import { Account } from '../../../types';
import { add } from '../..';

export async function connect(
  clientId: number,
  socialSiteId: number,
  auth: Auth,
): Promise<Account|null> {
  const socialSite = await socialSiteRepository.find(socialSiteId);
  const credentials = await getCredentials(socialSite.type, auth);
  if (credentials === null) return null;
  const accounts = await accountRepository.findAll(socialSite.type, auth, credentials);
  if (accounts.length !== 1) throw new Error(`Expected 1 account but got ${accounts.length}`);
  return add({
    clientId,
    socialSiteId,
    auth,
    credentials,
    externalId: accounts[0].id,
  });
}
